import React, { useState, useEffect } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Grid,
  TableContainer,
  Paper,
  Box,
  Collapse,
  CircularProgress,
  makeStyles,
  Typography,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import CommentIcon from "@material-ui/icons/Comment";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import CustomButton from "../projectsDashboard/CusomButton";
import CollapsibleForecastSchedule from "./CollapsibleForecastSchedule"; // Assuming this is your collapsible component
import { FETCH_ALL_FORECAST_SCHEDULES_LOADING } from "../../../containers/actions/types";
import { fetchAllForecastSchedules } from "../../../containers/actions/common/forecastScheduleActions";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import BackDropLoading from "../models/BackDrop";
import CachedIcon from "@material-ui/icons/Cached";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  refreshContainerSty: {
    display: "flex",
    justifyContent: "flex-end",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "flex-start",
      paddingTop: "1rem",
    },
    [theme.breakpoints.down("xs")]: {
      paddingTop: "1rem",
    },
  },
  refreshSty: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  padR20: {
    paddingRight: 20,
    [theme.breakpoints.down("xs")]: {
      paddingRight: 0,
    },
  },
}));

// Row Component to handle each row and its collapsible
const Row = ({ schedule, handleRefresh }) => {
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(false); // Track row expansion

  const handleExpandClick = () => {
    setIsExpanded(!isExpanded); // Toggle expand/collapse state
  };

  return (
    <React.Fragment>
      <TableRow>
        <TableCell
        // style={{ minWidth: "40px" }}
        >
          <IconButton onClick={handleExpandClick}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </TableCell>
        <TableCell
        //  style={{ minWidth: "130px" }}
        >
          {schedule.drugID}
        </TableCell>
        <TableCell
        // style={{ minWidth: "180px" }}
        >
          {schedule.drugName}
        </TableCell>
        {localStorage.collabType !== "CMO" ? (
          <TableCell
          // style={{ minWidth: "180px" }}
          >
            {schedule.cdmoOrgName}
          </TableCell>
        ) : (
          <TableCell
          // style={{ minWidth: "180px" }}
          >
            {schedule.sponsorOrgName}
          </TableCell>
        )}
        <TableCell
        // style={{ minWidth: "150px" }}
        >
          {schedule.poNumber}-{schedule.poLineItemNumber}
        </TableCell>
        <TableCell
        // style={{ minWidth: "160px", textAlign: "center" }}
        >
          {moment(schedule.initialSAPSyncDate).format("DD-MMM-YYYY")}
        </TableCell>
        <TableCell
        // style={{ minWidth: "160px", textAlign: "center" }}
        >
          {schedule.recentSAPSyncDate
            ? moment(schedule.recentSAPSyncDate).format("DD-MMM-YYYY")
            : "-NA-"}
        </TableCell>
        <TableCell style={{ textAlign: "right" }}>
          {schedule.collabrixForecastScheduleID}
        </TableCell>
        <TableCell style={{ textAlign: "center" }}>
          <Box
            style={{
              display: "inline-flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "4px",
              color: "orange",
              borderColor: "lightblue",
              borderStyle: "solid",
              borderWidth: "2px",
              borderRadius: "4px",
              minWidth: "200px",
              textAlign: "center",
            }}
          >
            {schedule.status}
          </Box>
        </TableCell>
        <TableCell style={{ display: "flex", textAlign: "center" }}>
          <IconButton>
            <CommentIcon />
          </IconButton>
          <IconButton>
            <EditIcon />
          </IconButton>
        </TableCell>
      </TableRow>

      {/* Collapsible Row Content */}
      {isExpanded && (
        <CollapsibleForecastSchedule
          schedule={schedule}
          isExpanded={isExpanded}
          handleRefresh={handleRefresh}
        />
      )}
    </React.Fragment>
  );
};

const DrugIDDetails = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const handleRefresh = () => {
    dispatch({
      type: FETCH_ALL_FORECAST_SCHEDULES_LOADING,
      payload: true,
    });
    dispatch(fetchAllForecastSchedules());
  };

  useEffect(() => {
    dispatch({
      type: FETCH_ALL_FORECAST_SCHEDULES_LOADING,
      payload: true,
    });
    dispatch(fetchAllForecastSchedules());
  }, []);

  const forecastSchedulesLoading = useSelector(
    (state) => state.pcmp.common.forecastSchedule.forecastSchedulesLoading
  );

  const forecastScheduleList = useSelector((state) =>
    state.pcmp.common.forecastSchedule.forecastSchedules?.data
      ? state.pcmp.common.forecastSchedule.forecastSchedules?.data
      : []
  );

  const errors = useSelector((state) =>
    state.pcmp.common.forecastSchedule.forecastSchedules
      ? state.pcmp.common.forecastSchedule.forecastSchedules
      : {
          status: false,
          errorDescription:
            "Something went wrong. Please contact Schrocken Suppport",
        }
  );

  return (
    <div>
      <BackDropLoading />
      {/* <Grid item xs={12} md={6} style={{ alignSelf: "self-end" }}> */}
      <Grid
        container
        spacing={2}
        justify="flex-end"
        style={{ marginBottom: "20px", paddingRight: "25px" }}
        className={classes.refreshContainerSty}
      >
        <Typography variant="caption" className={clsx(classes.padR20)}>
          {`Last synced @ ${moment(new Date()).format(
            "HH:mm:ss; DD MMMM YYYY"
          )}`}
        </Typography>

        <Typography
          variant="caption"
          color="primary"
          className={classes.refreshSty}
          onClick={handleRefresh}
        >
          Refresh
          <CachedIcon color="primary" style={{ fontSize: 15 }} />
        </Typography>
      </Grid>
      {/* </Grid> */}
      <Grid
        container
        spacing={2}
        justify="flex-end"
        style={{ marginBottom: "10px" }}
      >
        <CustomButton color="#F26336" hoverColor="#D8542E" textColor="#fff">
          Schedule Comparison
        </CustomButton>
        <CustomButton
          color="#F26336"
          hoverColor="#D8542E"
          textColor="#fff"
          style={{ marginLeft: "10px", marginRight: "10px" }}
        >
          Add New Schedule
        </CustomButton>
      </Grid>

      <TableContainer component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell
              //   style={{ minWidth: "40px" }}
              ></TableCell>
              <TableCell
              //   style={{ minWidth: "130px" }}
              >
                Drug ID
              </TableCell>
              <TableCell
              //   style={{ minWidth: "180px" }}
              >
                Drug Name
              </TableCell>
              {localStorage.collabType !== "CMO" ? (
                <TableCell>CMO</TableCell>
              ) : (
                <TableCell>BMS</TableCell>
              )}
              <TableCell
              //   style={{ minWidth: "150px" }}
              >
                {/* PO Details */}
                Forecast Details
              </TableCell>
              <TableCell
              //   style={{ minWidth: "160px", textAlign: "center" }}
              >
                Initial SAP Sync Date
              </TableCell>
              <TableCell
              //    style={{ minWidth: "160px", textAlign: "center" }}
              >
                Most Recent SAP Sync Date
              </TableCell>
              <TableCell style={{ textAlign: "right" }}>
                Forecast Schedule ID
              </TableCell>
              <TableCell style={{ textAlign: "center" }}>Status</TableCell>
              <TableCell style={{ textAlign: "center" }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {forecastSchedulesLoading ? (
              <TableRow>
                <TableCell colSpan={8}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center", // Horizontally center the CircularProgress
                      alignItems: "center", // Vertically center the CircularProgress
                      height: "100px", // Optional: Set a height to vertically center the loader
                    }}
                  >
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : forecastScheduleList.length > 0 ? (
              forecastScheduleList.map((schedule, index) => (
                <Row
                  key={index}
                  schedule={schedule}
                  handleRefresh={handleRefresh}
                />
              ))
            ) : errors.status === false ? (
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  Opacity: 1,
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                <TableCell colSpan={10} align="center">
                  {errors.errorDescription
                    ? errors.errorDescription
                    : "Please try again"}
                </TableCell>
              </TableRow>
            ) : (
              <TableRow style={{ border: "2px solid rgba(224, 224, 224, 1)" }}>
                <TableCell colSpan={10} align="center">
                  {"No Record Found"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default DrugIDDetails;
